module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "pg_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "id": "ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Acknowledgments")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("This book could not have been written without the tireless and wonderful assistance of Mike Zizzo, Director of Media Relations, at Texas Motor Speedway. Mike invited me to the Dickies 500 and gave me a media and a cold pass that allowed me in the garage and pit area. TMS is one of the top racing tracks in the country. The employees are friendly and knowledgeable. The experience is one I’ll never forget.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("Mike recommended I read "), _c('i', [_vm._v("NASCAR for Dummies")]), _vm._v(" by Mark Martin with Beth Tuschak before I attended the race. The book was invaluable and helped make sense of all the fast-paced action on and off the track. I highly recommend it if you want to know more about NASCAR. NASCAR.com is also a great place to find information.")]), _vm._v(" "), _c('p', {
    staticClass: "EX-CTR"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("Jim Gaughan, a NASCAR fan, who helped me understand the working of a NASCAR racing team and "), _c('span', {
    attrs: {
      "aria-label": "x",
      "id": "pg_x",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("why all those rows and rows of Goodyear tires were treadless.")])]), _vm._v(" "), _c('p', {
    staticClass: "EX-CTR"
  }, [_vm._v("Thanks also to the following people:")]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("McClinton Radford Jr., my only brother, and a former drag racer. Thank heaven big brothers don’t mind if you call and ask the same question again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("Kerry Tharp, NASCAR executive, who was kind enough to give me an interview and discuss diversity. Women and minorities are gaining visibility in NASCAR and making their mark.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_c('i', [_vm._v("NASCAR for Dummies")]), _vm._v(" by Mark Martin with Beth Tuschak")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0